'use strict';

var React = require('react');
require('prop-types');
var CurrencyDisplay = require('../CurrencyDisplay.js');
var PdfRenderableSplitRow = require('./PdfRenderableSplitRow.js');
var Typography = require('../../DesignSystem/DataDisplay/Typography/Typography.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var LendingPromoRow = function LendingPromoRow(_ref) {
  var amount = _ref.amount;
  return React__default["default"].createElement(PdfRenderableSplitRow, {
    leftContent: React__default["default"].createElement(Typography, {
      variant: "subtitle1"
    }, "or monthly payments as low as"),
    rightContent: React__default["default"].createElement(Typography, {
      variant: "subtitle1"
    }, React__default["default"].createElement(CurrencyDisplay, {
      amountInCents: amount
    }), "\xA0/ mo")
  });
};

module.exports = LendingPromoRow;
